<template>
  <Modal title="广告" v-model="isShow" @on-cancel="handle">
    <div class="myModal">
        <Form ref="advertInfos"  :model='advertInfos' label-position="right" :label-width="100" :rules="ruleValidate" @submit.native.prevent>
            <form-item label="标题" prop="advert_name">
              <Input placeholder="请输入标题" v-model="advertInfos.advert_name" disabled></Input>
            </form-item>
          <FormItem label="图片URL">
            <div class="demo-upload-list" v-for="item in uploadList" :key="item.url" >
              <template v-if="item.status === 'finished'">
                <img :src="item.url">
                <div class="demo-upload-list-cover">
                  <Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
                  <Icon type="ios-trash-outline" @click.native="handleRemove(item)"></Icon>
                </div>
              </template>
              <template v-else>
                <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
              </template>
            </div>
            <Upload
              v-if="uploadList.length==0"
              ref="uploadThumb"
              :show-upload-list="false"
              :on-success="handleSuccess"
              :format="['jpg','jpeg','png','gif']"
              :max-size="10240"
              :on-format-error="handleFormatError"
              :on-exceeded-size="handleMaxSize"
              :before-upload="handleBeforeUpload"
              type="drag"
              :action="serverApiPic"
              style="display: inline-block;width:58px;">
              <div style="width: 58px;height:58px;line-height: 58px;">
                <Icon type="ios-camera" size="20"></Icon>
              </div>
            </Upload>

            <Modal title="查看" v-model="visible">
              <img :src="imgUrl " v-if="visible" style="width: 100%">
            </Modal>
          </FormItem>
        </Form>
    </div>
    <div slot="footer">
        <Button type="primary"   @click="handleOk('advertInfos')">确定</Button>
    </div>
  </Modal>
</template>
<style scoped>
  .myModal {
    margin-left: 20px;
    margin-top: 20px;
  }
   .demo-upload-list{
     display: inline-block;
     width: 60px;
     height: 60px;
     text-align: center;
     line-height: 60px;
     border: 1px solid transparent;
     border-radius: 4px;
     overflow: hidden;
     background: #fff;
     position: relative;
     box-shadow: 0 1px 1px rgba(0,0,0,.2);
     margin-right: 4px;
   }
  .demo-upload-list img{
    width: 100%;
    height: 100%;
  }
  .demo-upload-list-cover{
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,.6);
  }
  .demo-upload-list:hover .demo-upload-list-cover{
    display: block;
  }
  .demo-upload-list-cover i{
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
  }
</style>
<script>
import { addAdv, advertApi } from '@/api/advert'
import Setting from '@/setting'
export default {
  name: 'picEdit',
  props: ['editShow', 'id'],
  data () {
    return {
      selectShow: false,
      article_name: '',
      server_url: Setting.serverSrc,
      serverApiPic: Setting.serverApiPic,
      isShow: false,
      advert_id: 0,
      uploadList: [], // 缩咯图
      uploadPicLimit: 1,
      imgUrl: '',
      visible: false,
      advertInfos: {
        advert_id: 0,
        pic_url: '',
        type: 2,
        adv_type: 1
      },
      ruleValidate: {
      }
    }
  },
  watch: {
    editShow (val) {
      this.isShow = val
      this.advertInfos.advert_id = 0
      this.advertInfos.pic_url = ''
      this.advertInfos.type = 2
      this.advertInfos.status = 1
      this.advertInfos.article_id = 0
    },
    id (val) {
      this.advert_id = val
      if (this.advert_id > 0) {
        this.advertInfo()
      }
    },
    adv_group_id (val) {
      this.advertInfos.adv_group_id = val
    }
  },
  mounted () {
  },
  methods: {
    handle (status) {
      this.$emit('updateStatusModel', false)
    },
    handleOk (name) {
      if (this.uploadList.length <= 0) {
        this.$Message.error('广告图必填')
        return
      }
      let urls = ''
      if (this.uploadList.length > 0) {
        let i = 0
        for (i; i < this.uploadList.length; i++) {
          urls += this.uploadList[i]['url'] + ','
        }
        urls = urls.slice(0, urls.length - 1)
      }
      this.advertInfos.pic_url = urls !== '' ? urls : this.artInfo.pic_url
      this.$refs[name].validate(valid => {
        if (valid) {
          addAdv(this.advertInfos).then(res => {
            let msg = '添加成功'
            if (this.advertInfos.advert_id > 0) {
              msg = '编辑成功'
            }
            if (res.code === 200) {
              this.$Message.success(msg)
              this.$emit('updateStatusModel', false)
            } else {
              this.$Message.error(res.msg)
            }
          }).catch(res => {
            this.$Message.error(res.msg)
          })
        }
      })
    },
    advertInfo () {
      if (this.advert_id) {
        let data = { 'advert_id': this.advert_id }
        advertApi(data).then(res => {
          this.advertInfos = res.data
          this.article_name = this.advertInfos.article_name
          this.uploadList.push({ 'url': this.advertInfos.pic_url, 'showProgress': false, 'percentage': 100, 'status': 'finished' })
        }).catch(res => {
          this.$Message.error(res.msg)
        })
      }
    },
    handleView (url) {
      this.imgUrl = url
      this.visible = true
    },
    // 缩略图删除
    handleRemove (file) {
      const fileList2 = this.uploadList
      this.uploadList.splice(fileList2.indexOf(file), 1)
      this.uploadList = []
    },
    // 缩略图
    handleSuccess (res, file) {
      let file_url = res.data.file_url
      file.url = file_url
      // if (file_url.substring(0, 5) === 'https') {
      //   file.url = file_url
      // } else {
      //   file.url = this.server_url + file_url
      // }
      this.uploadList = this.$refs.uploadThumb.fileList
    },
    handleFormatError (file) {
      this.$Message.error('文件' + file.name + '格式错误，请上传jpg、png、gif')
    },
    handleMaxSize (file) {
      this.$Message.error('文件' + file.name + '太大，不能大于10M')
    },
    // 缩略图
    handleBeforeUpload () {
      const check = this.uploadList.length <= 1
      if (!check) {
        this.$Message.error('只能上传1张图片')
      }
      return check
    },
    updateStatusModel (modalStatus) {
      this.selectShow = modalStatus
    },
    closeModal (val) {
      if (val) {
        this.confirm = false
        this.selectShow = false
      }
    }
  }
}
</script>
